/* Naht & Leinen – 1-Klick-Set-Upgrade in der Warenkorb-Schublade (Snippet nl-cart-set-upgrade).
   Ablauf: Set-Variante hinzufügen (/cart/add.js), danach den Einzel-Beaubag entfernen (/cart/change.js mit sections).
   So geht nie etwas verloren: Scheitert Schritt 2, liegen kurz beide Artikel im Warenkorb und die Schublade zeigt das an.
   Neu zeichnen: Craft/Dawn cart-drawer.renderContents(), sonst Fallback über die Section-Rendering-API. */
(() => {
  if (window.nlSetUpgrade) return;
  window.nlSetUpgrade = true;

  const wurzelPfad = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = (url, daten) => fetch(`${wurzelPfad}${url}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(daten),
  }).then(async (r) => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok || d.status) throw new Error(d.description || d.message || `Fehler ${r.status}`);
    return d;
  });

  const abschnitte = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map((s) => s.section || s.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  };

  const neuZeichnen = (zustand) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && zustand.sections) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(zustand);
      return;
    }
    // Fallback: Inneres der Schublade und Warenkorb-Symbol direkt ersetzen
    const html = zustand.sections || {};
    const ersetzen = (sectionId, selektor) => {
      if (!html[sectionId]) return;
      const neu = new DOMParser().parseFromString(html[sectionId], 'text/html').querySelector(selektor);
      const alt = document.querySelector(selektor);
      if (neu && alt) alt.innerHTML = neu.innerHTML;
    };
    ersetzen('cart-drawer', '.drawer__inner');
    ersetzen('cart-icon-bubble', '#cart-icon-bubble');
  };

  document.addEventListener('click', async (e) => {
    const knopf = e.target.closest('[data-nl-upgrade-knopf]');
    if (!knopf) return;
    const karte = knopf.closest('[data-nl-upgrade]');
    const status = karte.querySelector('.nl-upgrade__status');
    const { altKey, neuId, menge } = karte.dataset;
    if (knopf.getAttribute('aria-busy') === 'true') return;

    knopf.setAttribute('aria-busy', 'true');
    knopf.disabled = true;
    const text = knopf.textContent;
    knopf.textContent = 'Einen Moment, wir tauschen …';
    status.textContent = '';

    try {
      await json('cart/add.js', { items: [{ id: Number(neuId), quantity: Number(menge) || 1 }] });
      const zustand = await json('cart/change.js', {
        id: altKey,
        quantity: 0,
        sections: abschnitte(),
        sections_url: window.location.pathname,
      });
      neuZeichnen(zustand);
      // Andere Bausteine (z. B. Versandleiste, Zähler) informieren, wie Craft es selbst tut
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nl-set-upgrade', cartData: zustand });
      }
      const live = document.getElementById('CartDrawer-LiveRegionText');
      if (live) live.textContent = 'Das Set liegt jetzt im Warenkorb.';
      try { window.Shopify?.analytics?.publish?.('nl_set_upgrade', { neuId }); } catch (err) { /* egal */ }
    } catch (fehler) {
      knopf.disabled = false;
      knopf.removeAttribute('aria-busy');
      knopf.textContent = text;
      status.textContent = 'Das hat gerade nicht geklappt. Bitte versuch es noch einmal.';
    }
  });
})();
